import React from 'react';
import { CategoryItem, Col, Row } from 'seduo-ui';
const CategoryList = ({ items, showBoxes, showIcons }) => showBoxes ? (<Row className="categories categories--boxes" noGutters>
            {items.map((item, index) => (<Col xs={6} md={4} lg={2} key={`category_item_${index}`}>
                    <CategoryItem title={item.title} link={item.link} iconKind={item.iconKind} showBoxes showIcon={showIcons} isActive={item.isActive}/>
                </Col>))}
        </Row>) : (<div className="categories">
            {items.map((item, index) => (<CategoryItem key={`category_item_${index}`} title={item.title} link={item.link} iconKind={item.iconKind} showIcon={showIcons} isActive={item.isActive}/>))}
        </div>);
CategoryList.defaultProps = {
    showBoxes: false,
    showIcons: true,
};
export default CategoryList;
